import { render } from "./MoreStories.vue?vue&type=template&id=7332f83e&scoped=true"
import script from "./MoreStories.vue?vue&type=script&lang=js"
export * from "./MoreStories.vue?vue&type=script&lang=js"

import "./MoreStories.vue?vue&type=style&index=0&id=7332f83e&scoped=true&lang=css"

import exportComponent from "/builds/site-palette/palette.site-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7332f83e"]])

export default __exports__